import script from "./WidgetNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetNotifications.vue?vue&type=script&setup=true&lang=js"

import "./WidgetNotifications.vue?vue&type=style&index=0&id=dd9c63c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd9c63c0"]])

export default __exports__